/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {RulesetListPageComponent} from './ruleset-list-page.component';

@Component({
  standalone: true,
  imports: [RulesetListPageComponent],
  selector: 'adn-ruleset-route-page',
  template: `
    <adn-ruleset-list-page [readOnly]="readOnly"></adn-ruleset-list-page>
  `
})
export class RulesetRoutePageComponent {
  @Input() readOnly = false;
}
